// src/pages/UserDashboard.jsx
function UserDashboard() {
    return (
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <h1>Welcome to Your Dashboard 🎉</h1>
        <p>This is a protected page only accessible to logged-in users.</p>
      </div>
    );
  }
  
  export default UserDashboard;
  